// src/utils/loadMetaPixel.js
export function loadMetaPixel() {
    if (typeof window === 'undefined') return;

    const isProd = window.location.hostname === 'mima-italia.it'
        || window.location.hostname === 'www.mima-italia.it';
    if (!isProd) {
        console.log('[MetaPixel] Ambiente non di produzione, pixel non caricato:', window.location.hostname);
        return;
    }

    if (window.__metaPixelLoaded) return;
    window.__metaPixelLoaded = true;

    const fbq = window.fbq = function () {
        fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);

    window.fbq('init', '1277090381224976');
    window.fbq('track', 'PageView');
    // 'consent grant' rimosso da qui � va chiamato solo dopo consenso reale dell'utente,
    // non incondizionatamente al load. Vedi nota sopra.
}